module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "pb-0",
    class: {
      'height': _vm.$vuetify.breakpoint.lgAndUp, 'grey lighten-4': !_vm.$vuetify.dark, 'grey darken-4': _vm.$vuetify.dark
    },
    attrs: {
      "fixed": "",
      "app": "",
      "clipped": "",
      "floating": "",
      "disable-route-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    staticClass: "mb-2",
    attrs: {
      "to": {
        name: 'Browse'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4 "
  }, [_vm._v("album")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Browse")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.user.isAuthenticated) ? [_c('v-subheader', {
    staticClass: "ml-3 body-2 grey--text"
  }, [_vm._v("\n                LIBRARY\n                ")]), _vm._v(" "), _c('v-list-tile', {
    key: "history",
    staticClass: "playlist",
    attrs: {
      "to": "/history"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4"
  }, [_vm._v("history")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("History")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    key: "likes",
    staticClass: "playlist",
    attrs: {
      "to": "/likes"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4"
  }, [_vm._v("favorite")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Likes")])], 1)], 1), _vm._v(" "), _vm._l((_vm.user.user.playlists), function(playlist, i) {
    return (i < 3 || _vm.showMore) ? _c('v-list-tile', {
      key: playlist.id,
      staticClass: "playlist",
      attrs: {
        "to": {
          name: 'Playlist',
          params: {
            id: playlist.id
          }
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "ml-3 mr-4",
      domProps: {
        "textContent": _vm._s(playlist.title === 'Liked' ? 'favorite' : playlist.title === 'History' ? 'history' : 'playlist_play')
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(playlist.title))])], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.user.user.playlists.length > 3) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.showMore = !_vm.showMore
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4",
    domProps: {
      "textContent": _vm._s(_vm.showMore ? 'keyboard_arrow_up' : 'keyboard_arrow_down')
    }
  })], 1), _vm._v(" "), (_vm.showMore) ? [_vm._v("Show Less")] : [_vm._v("Show More")]], 2) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-subheader', {
    staticClass: "ml-3 body-2 grey--text"
  }, [_vm._v("\n                    CONTRIBUTE\n                ")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'TracksCreate'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "ml-3 mr-4 "
  }, [_vm._v("add_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Add a track")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.toggleTheme
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    staticClass: "pt-2",
    attrs: {
      "label": "",
      "color": "grey darken-3",
      "hide-details": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.dark),
      callback: function($$v) {
        _vm.dark = $$v
      },
      expression: "dark"
    }
  })], 1), _vm._v("\n                Theme: " + _vm._s(this.dark ? 'Dark' : 'Light') + "\n\n            ")], 1)] : _vm._e()], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-list', {
    staticClass: "grey--text footer"
  }, [_c('v-list-tile')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abd36e96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheLeftSidebar/TheLeftSidebar.vue
// module id = 395
// module chunks = 0